import { render, staticRenderFns } from "./AmazonBudgetRule.vue?vue&type=template&id=a4f3f266&scoped=true&lang=pug"
import script from "./AmazonBudgetRule.js?vue&type=script&lang=js&external"
export * from "./AmazonBudgetRule.js?vue&type=script&lang=js&external"
import style0 from "./AmazonBudgetRule.sass?vue&type=style&index=0&id=a4f3f266&prod&lang=sass&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4f3f266",
  null
  
)

export default component.exports